export const slugifyTourName = (value) => {
    if (!value) return 'tour';
    const slug = String(value)
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
    return slug || 'tour';
};

export const getTourSlug = (tour) => {
    const slug = tour?.slug ?? tour?.Slug;
    if (slug) return slug;
    return slugifyTourName(tour?.name ?? tour?.Name ?? tour?.title);
};

export const buildTourDetailPath = (tour) => {
    const id = tour?.id ?? tour?.Id;
    if (!id) return '/destination-listing';
    const slug = getTourSlug(tour);
    return `/destination-detail/${slug}/${id}`;
};
